import './index.css';
import React from 'react';
import {RouterProvider} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useTenant} from '@/shared/hooks/useTenant';
import {router} from './router';
import {CartProvider} from '@/modules/shop/context/CartContext';

function AppContent() {
    const {loading, error} = useTenant();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p className="text-gray-600">Loading organization...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50">
                <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
                    <div className="text-mld-danger mb-4">
                        <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            />
                        </svg>
                    </div>
                    <h1 className="text-2xl font-semibold text-gray-900 mb-2">Organization Not Found</h1>
                    <p className="text-gray-600 mb-4">{error}</p>
                    <p className="text-sm text-gray-500">
                        Please check the URL and try again, or contact support for assistance.
                    </p>
                </div>
            </div>
        );
    }

    // CartProvider sits above the router so cart state persists across
    // every route — patients can add a Custom Lab Package from the
    // dashboard hero and still see it when they navigate to /shop.
    return (
        <CartProvider>
            <RouterProvider router={router} />
        </CartProvider>
    );
}

function App() {
    return (
        <>
            <AppContent />
            <ToastContainer position="top-right" autoClose={4000} hideProgressBar newestOnTop />
        </>
    );
}

export default App;
